import React from 'react';
import { useBank } from '../../hooks/useBank';
import { useInventory } from '../../hooks/useInventory';
import { DevConfig } from '../../../../config/environment/devConfig';
import { BankView } from './bank/BankView';
import { useCurrentMapId } from '../WorldMap/WorldMapWindow';

/**
 * BankContent — the `bank` window body, propless. WindowHost mounts it inside
 * the shared ToolWindow chrome; it wires the authoritative bank (useBank) and
 * the bag (useInventory) into the presentational BankView (bank/BankView.tsx),
 * dressed in the current zone's tome vibe.
 */
export const BankContent: React.FC = () => {
  const bank = useBank();
  const { items, gold, maxSlots } = useInventory();
  const zoneId = useCurrentMapId();
  return <BankView bank={bank} inventory={{ items, gold, maxSlots }} zoneId={zoneId}
    showTestGear={DevConfig.systems.debugToolbox} />;
};
